/**
 * 应用配置文件
 * 集中管理所有配置项，支持环境变量覆盖
 */

// 从环境变量读取配置，如果没有则使用默认值
const getEnvVar = (key, defaultValue) => {
  return process.env[key] || defaultValue;
};

// API 配置
export const apiConfig = {
  baseURL: getEnvVar('VUE_APP_API_BASE_URL', 'https://api.sharesdu.com/index/api'),
};

// 学院列表
export const colleges = [
  "哲学与社会发展学院",
  "经济学院",
  "文学院",
  "历史学院",
  "考古学院",
  "数学学院",
  "物理学院",
  "化学与化工学院",
  "管理学院",
  "马克思主义学院",
  "国际教育学院",
  "经济研究院",
  "儒学高等研究院（文史哲研究院）",
  "外国语学院（大学外语教学部）",
  "晶体材料研究院",
  "中泰证券金融研究院",
  "新闻传播学院",
  "新一代半导体材料研究院",
  "人工智能学院",
  "艺术学院",
  "基础医学院",
  "公共卫生学院",
  "口腔医学院",
  "护理与康复学院",
  "药学院",
  "第一临床学院",
  "第二临床学院",
  "医学融合与实践中心",
  "材料科学与工程学院",
  "机械工程学院",
  "控制科学与工程学院",
  "能源与动力工程学院",
  "电气工程学院",
  "土建与水利学院",
  "体育学院",
  "软件学院",
  "集成电路学院",
  "中加合作办学项目",
  "人工智能国际联合研究院",
  "智能创新研究院",
  "齐鲁交通学院",
  "未来技术学院",
  "东北亚学院",
  "翻译学院",
  "空间科学与物理学院",
  "商学院",
  "数学与统计学院",
  "法学院",
  "海洋学院",
  "文化传播学院",
  "机电与信息工程学院",
  "山东大学澳国立联合理学院",
  "体育教学部",
  "政治学与公共管理学院",
  "信息科学与工程学院",
  "计算机科学与技术学院",
  "生命科学学院",
  "环境科学与工程学院",
  "国际创新转化学院",
  "网络空间安全学院",
  "前沿交叉科学青岛研究院",
  "人文社会科学青岛研究院",
  "微生物技术研究院",
  "环境研究院",
  "海洋研究院",
  "数学与交叉科学研究中心",
  "暂无"
];

// 校区列表
export const campus = [
  "中心校区",
  "千佛山校区",
  "兴隆山校区",
  "趵突泉校区",
  "洪家楼校区",
  "威海校区",
  "软件园校区",
  "青岛校区"
];

// 课程类型
export const courseTypes = [
  '必修课',
  '限选课',
  '选修课',
];

// 教学方式
export const teachMethods = [
  '线上',
  '线下',
  '混合'
];

// 考核方式
export const examineMethods = [
  '考试',
  '论文',
  '项目展示',
  '其他'
];

// 主题配置
export const themeConfig = {
  defaultColor: getEnvVar('VUE_APP_THEME_COLOR', '#9c0c13'),
};

// 邮箱配置
export const emailConfig = {
  suffix: getEnvVar('VUE_APP_EMAIL_SUFFIX', '@mail.sdu.edu.cn'),
  studentIdHint: '请输入学号，系统将自动添加邮箱后缀',
};

// 版本配置
export const versionConfig = {
  globalVersion: getEnvVar('VUE_APP_VERSION', '-0.0.0'),
};

// 图片资源字典配置
export const getImageDict = () => {
  const origin = window.location.origin;
  return {
    svg: {
      lazy: `${origin}/resource/default_img.svg`,
      reviewing: `${origin}/resource/reviewing.svg`,
      empty: `${origin}/resource/no_img.svg`,
      notFound: `${origin}/resource/404.svg`,
      unreviewed: `${origin}/resource/review_failed.svg`,
      upload: `${origin}/resource/upload.svg`,
    },
    png: {
      lazy: `${origin}/resource/default_img.svg`,
      reviewing: `${origin}/resource/reviewing.svg`,
      empty: `${origin}/resource/no_img.svg`,
      notFound: `${origin}/resource/404.svg`,
      unreviewed: `${origin}/resource/review_failed.svg`,
    },
    test: {
      lazy: `${origin}/resource/default_img.png`,
      reviewing: `${origin}/resource/reviewing.png`,
      empty: `${origin}/resource/no_img.png`,
      notFound: `${origin}/resource/404.png`,
      unreviewed: `${origin}/resource/review_failed.png`,
    }
  };
};

// 服务卡片配置
export const services = [
  {
    title:'计算机专业分享',
    link: 'https://sducsguide.github.io/SDUCSGuide/',
    description: 'Github上山东大学计算机专业的一些资料聚合',
    category: '计算机',
    source: '山东大学',
    icon: 'mdi-laptop',
  },
  {
    title:'物理实验室',
    link: 'https://physics.sharesdu.com',
    description:'适合高中物理实验制作课件，教学演示等',
    category:'实用工具',
    source:'佚名',
    icon: 'mdi-motion-play-outline'
  },
  {
    title: '信息服务平台',
    link: 'https://service.sdu.edu.cn',
    description: '山东大学统一信息服务平台，提供各类校园信息服务',
    category: '信息服务',
    source: '山东大学',
    icon: 'mdi-web',
  },
  {
    title: '山大云盘',
    link: 'https://icloud.qd.sdu.edu.cn:7777/#/',
    description: '山东大学云存储服务，安全便捷的文件存储与分享',
    category: '云服务',
    source: '山东大学',
    icon: 'mdi-cloud-outline',
  },
  {
    title: '青岛校区微公交',
    link: 'https://101.76.229.73',
    description: '青岛校区微公交查询系统，方便师生出行',
    category: '交通',
    source: '山东大学',
    icon: 'mdi-bus',
  },
  {
    title: '山大公交查询',
    link: 'http://www.sd114.sdu.edu.cn:8080/web/bus/index',
    description: '山东大学各校区班车时刻表查询，实时掌握班车信息',
    category: '交通',
    source: '山东大学',
    icon: 'mdi-bus-clock',
  },
  {
    title: '山大调查问卷系统',
    link: 'https://wenjuan.sdu.edu.cn/',
    description: '山大官方问卷系统，可进行身份认证问卷填写',
    category: '信息服务',
    source: '山东大学',
    icon: 'mdi-file-question-outline',
  },
  {
    title: '山大图书馆',
    link: 'https://lib.sdu.edu.cn/',
    description: '山东大学图书馆，提供图书借阅和查询服务',
    category: '图书馆',
    source: '山东大学',
    icon: 'mdi-library-outline',
  },
  {
    title: '山东大学校友网',
    link: 'https://www.sdu.org.cn/xwkx/xyzh.htm',
    description: '山大校友网，包含校友组织信息',
    category: '校友',
    source: '山东大学',
    icon: 'mdi-account-group',
  },
  {
    title: '山大缴费平台',
    link: 'https://pay.sdu.edu.cn/payment/login.jsp',
    description: '在线缴费服务平台，支持各类费用缴纳',
    category: '财务',
    source: '山东大学',
    icon: 'mdi-credit-card-outline',
  },
  {
    title: '山大AI助手',
    link: 'https://aiassist.sdu.edu.cn/page/',
    description: '智能AI助手，提供智能问答和辅助服务',
    category: 'AI服务',
    source: '山东大学',
    icon: 'mdi-robot-outline',
  },
  {
    title: '山大Agent平台',
    link: 'https://agentlab.sdu.edu.cn',
    description: '智能Agent实验平台，探索AI智能体应用',
    category: 'AI服务',
    source: '山东大学',
    icon: 'mdi-brain',
  },
  {
    title: '山大学生邮箱',
    link: 'http://mail.sdu.edu.cn/',
    description: '山东大学学生邮箱，提供邮箱服务',
    category: '邮箱',
    source: '山东大学',
    icon: 'mdi-email-outline',
  },
  {
    title: '拓展培养系统',
    link: 'http://222.194.64.76/',
    description: '山东大学拓展培养系统，可以查询志愿时长等信息',
    category: '拓展培养',
    source: '山东大学',
    icon: 'mdi-school',
  }
];

// 用户身份配置
// 格式：{ userId: 'role' }，role 为身份类型
// 优先级从高到低：admin > verified > developer > moderator > contributor
export const userRoles = {
  // 示例配置，实际使用时替换为真实用户ID
  // 'user_id_1': 'admin',
  // 'user_id_2': 'verified',
  // 'user_id_3': 'developer',
  // 'user_id_4': 'moderator',
  // 'user_id_5': 'contributor',
  '1':'admin',
  '2':'admin',
  '3':'admin',
  '364':'verified',
};

// 身份类型定义及优先级
export const roleConfig = {
  admin: {
    priority: 100,
    label: '管理员',
    icon: 'mdi-shield-check',
    color: '#c0c0c0',
    bgColor: 'rgba(176, 176, 176, 0.1)',
  },
  verified: {
    priority: 80,
    label: '官方认证',
    icon: 'mdi-check-decagram',
    color: '#64B5F6',
    bgColor: 'rgba(100, 181, 246, 0.1)',
  },
  developer: {
    priority: 60,
    label: '开发者',
    icon: 'mdi-code-braces',
    color: '#81C784',
    bgColor: 'rgba(129, 199, 132, 0.1)',
  },
  moderator: {
    priority: 40,
    label: '版主',
    icon: 'mdi-star',
    color: '#BA68C8',
    bgColor: 'rgba(186, 104, 200, 0.1)',
  },
  contributor: {
    priority: 20,
    label: '贡献者',
    icon: 'mdi-heart',
    color: '#FFB74D',
    bgColor: 'rgba(255, 183, 77, 0.1)',
  },
};
export const adminEmail = "admin@sharesdu.com";
// 导出所有配置
export default {
  api: apiConfig,
  colleges,
  campus,
  courseTypes,
  teachMethods,
  examineMethods,
  theme: themeConfig,
  version: versionConfig,
  email: emailConfig,
  services,
  getImageDict,
  userRoles,
  roleConfig,
  adminEmail,
};